import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { RichiesteCausaliCDLApi } from "../data/apis";
import { useMemo } from "react";

export function useRichiestaFerieDataSource() {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new RichiesteCausaliCDLApi(apiConfiguration);

        return new CustomStore({
            key: "id",
            loadMode: "raw",
            load: (loadOptions) => {
                return api.getRichiesteCausaliCdl();
            }
        })
    }, []);

    return dataSource;
}